export default __webpack_public_path__ + "static/media/metro.8e86dd93.jpg";